<script>
export default {
    name: 'ValidationRecurrenceList',
    props: {
        listAtendimentos: { type: Array, required: true },
        perPage: { type: Number, required: false, default: 10 },
        totalRows: { type: Number, required: false, default: 0 },
        currentPage: { type: Number, required: false, default: 1 },
    },
    data() {
        return {
            localCurrentPage: this.currentPage,
            optionsPages: [
                { value: 10, text: '10' },
                { value: 25, text: '25' },
                { value: 50, text: '50' },
                { value: 100, text: '100' },
                { value: 500, text: '500' },
                { value: 1000, text: '1000' },
            ],
            fields: [
                { key: 'select', label: '', sortable: false, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'id', label: 'Código', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
                { key: 'agenda_id', label: 'Agenda', type: 'integer', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
                { key: 'is_cancelled', label: 'Cancelado', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'pacient', label: 'Paciente', sortable: true, thClass: 'text-center', tdClass: 'text-left' },
                { key: 'agreement', label: 'Convênio', sortable: true, thClass: 'text-center', tdClass: 'text-left' },
                { key: 'start', label: 'Data', type: 'date', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'start_time', label: 'Início', type: 'time', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'end_time', label: 'Fim', type: 'time', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'conta_pagar_id', label: 'Conta', type: 'integer', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
                { key: 'service_value', label: 'Valor Atendimento', type: 'float', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
                { key: 'transfer_amount', label: 'Repasse', type: 'float', sortable: true, thClass: 'text-center', tdClass: 'text-right' },
                { key: 'desc', label: 'Parecer', sortable: true, thClass: 'text-center', tdClass: 'text-left' },
                { key: 'is_billed', label: 'Faturado', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
            ],
            selectedIds: [],
            parecerImageModal: false,
            parecerImageSrc: null,
            currentEmpresaId: 0,
        }
    },
    computed: {
        allSelected() {
            if (!this.listAtendimentos || this.listAtendimentos.length === 0) return false
            const values = this.listAtendimentos.map(item => this.getRowValue(item))
            return values.every(v => this.selectedIds.includes(v))
        },
        isIndeterminate() {
            return this.selectedIds.length > 0 && !this.allSelected
        },
        totalServiceValue() {
            return this.listAtendimentos.reduce((acc, item) => acc + (Number(item.service_value) || 0), 0)
        },
        totalTransferAmount() {
            return this.listAtendimentos.reduce((acc, item) => acc + (Number(item.transfer_amount) || 0), 0)
        },
        selectedItems() {
            if (!this.selectedIds || this.selectedIds.length === 0) return []
            return this.listAtendimentos.filter(item => {
                const itemId = this.getRowValue(item)
                return this.selectedIds.includes(itemId)
            })
        },
        selectedCancelledCount() {
            return this.selectedItems.filter(item => item.is_cancelled).length
        },
        selectedNotCancelledCount() {
            return this.selectedItems.filter(item => !item.is_cancelled).length
        },
    },
    watch: {
        currentPage(newVal) {
            this.localCurrentPage = newVal
        },
        listAtendimentos: {
            immediate: true,
            handler(newList) {
                const validIds = newList.map(item => this.getRowValue(item))
                const oldLength = this.selectedIds.length
                this.selectedIds = this.selectedIds.filter(id => validIds.includes(id))
                
                // Se a lista mudou e há selecionados, recalcula estatísticas
                if (this.selectedIds.length > 0 && oldLength !== this.selectedIds.length) {
                    const selectedItems = newList.filter(item => {
                        const itemId = this.getRowValue(item)
                        return this.selectedIds.includes(itemId)
                    })
                    const cancelled = selectedItems.filter(item => item.is_cancelled).length
                    const notCancelled = selectedItems.filter(item => !item.is_cancelled).length
                    
                    this.$emit('change-selected-stats', {
                        cancelled,
                        notCancelled,
                        total: this.selectedIds.length
                    })
                } else if (this.selectedIds.length === 0) {
                    this.$emit('change-selected-stats', {
                        cancelled: 0,
                        notCancelled: 0,
                        total: 0
                    })
                }
            },
        },
        selectedIds: {
            handler(newSelected) {
                this.$emit('change-selected', newSelected)
                
                // Calcula estatísticas dos selecionados
                if (newSelected && newSelected.length > 0) {
                    const selectedItems = this.listAtendimentos.filter(item => {
                        const itemId = this.getRowValue(item)
                        return newSelected.includes(itemId)
                    })
                    const cancelled = selectedItems.filter(item => item.is_cancelled).length
                    const notCancelled = selectedItems.filter(item => !item.is_cancelled).length
                    
                    this.$emit('change-selected-stats', {
                        cancelled,
                        notCancelled,
                        total: newSelected.length
                    })
                } else {
                    this.$emit('change-selected-stats', {
                        cancelled: 0,
                        notCancelled: 0,
                        total: 0
                    })
                }
            },
            deep: true,
        },
    },
    methods: {
        getRowValue(item) {
            return (item && item.id != null) ? item.id : item.agenda_id
        },
        toggleAll(checked) {
            if (checked) {
                this.selectedIds = this.listAtendimentos.map(item => this.getRowValue(item))
            } else {
                this.selectedIds = []
            }
        },
        truncate(text, max) {
            if (!text) return ''
            const value = String(text)
            return value.length > max ? value.substring(0, max) + '…' : value
        },
        stripHtml(text) {
            if (!text) return ''
            return String(text).replace(/<[^>]*>/g, ' ')
        },
        normalizeCkeditorImageSrc(src) {
            if (!src || typeof src !== 'string') return null

            // Corrige entidades HTML que chegam no HTML bruto (ex.: `&amp;` vira parte literal do src)
            // para que o navegador consiga requisitar a query string corretamente.
            let cleaned = src
            cleaned = cleaned.replace(/&amp;/g, '&')
            cleaned = cleaned.replace(/&quot;/g, '"')
            cleaned = cleaned.replace(/&#39;/g, "'")

            // Se já é o proxy estável, mantém
            if (cleaned.includes('/api/ckeditor/image')) return cleaned

            // Extrai a chave S3 mesmo se a URL assinada estiver expirada (com query string)
            // Pode vir tanto como `evolucoes/imagens/...` quanto codificado `evolucoes%2Fimagens%2F...`
            let decoded = cleaned
            try {
                decoded = decodeURIComponent(cleaned)
            } catch (e) {
                decoded = cleaned
            }

            const match =
                decoded.match(/(evolucoes\/imagens\/[^?]+)/i) ||
                // fallback: às vezes o path vem parcialmente codificado antes do decode funcionar
                cleaned.match(/(evolucoes%2Fimagens%2F[^?]+)/i) ||
                null

            const key = match ? match[1] : null
            if (!key) return src

            const baseUri = process.env.VUE_APP_BASEURI || ''
            return `${baseUri}/api/ckeditor/image?path=${encodeURIComponent(key)}&empresa_id=${this.currentEmpresaId || 0}`
        },
        getFirstImageSrc(html) {
            if (!html) return null
            if (typeof html !== 'string') return null
            const match = html.match(/<img[^>]+src=["']([^"']+)["']/i)
            return match ? this.normalizeCkeditorImageSrc(match[1]) : null
        },
        openParecerImage(src) {
            if (!src) return
            this.parecerImageSrc = this.normalizeCkeditorImageSrc(src)
            this.parecerImageModal = true
        },
        handlePageChange(page) {
            this.localCurrentPage = page
            this.$emit('change-page', page)
        },
    },
    mounted() {
        try {
            const ce = JSON.parse(localStorage.getItem('currentEmpresa'))
            this.currentEmpresaId = ce && ce.id ? ce.id : 0
        } catch (e) {
            this.currentEmpresaId = 0
        }
    }
}
</script>

<template>
    <div class="card-body pt-0">
        <b-modal
            v-model="parecerImageModal"
            :title="'Parecer imagem'"
            hide-footer
            no-close-on-backdrop
            size="xl"
            :dialog-class="'parecer-image-dialog'"
        >
            <div class="d-flex justify-content-center align-items-center">
                <img
                    v-if="parecerImageSrc"
                    :src="parecerImageSrc"
                    class="parecer-image-modal-img"
                    alt="Parecer imagem"
                />
            </div>
        </b-modal>

        <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
                <div id="responsible-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        Exibir&nbsp;
                        <b-form-select :value="perPage" @input="$emit('change-per-page', $event)" :options="optionsPages" size="sm"></b-form-select>&nbsp;registros
                    </label>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="table-responsive mb-0 small">
                <b-table
                    id="validation-recurrence-list"
                    :items="listAtendimentos"
                    :fields="fields"
                    responsive="sm"
                    small
                    hover
                    striped
                    :foot-clone="true"
                    show-empty
                    empty-text="Nenhum registro encontrado"
                    class="validation-table"
                >
                    <template #head(select)>
                        <b-form-checkbox
                            :indeterminate="isIndeterminate"
                            :checked="allSelected"
                            @change="toggleAll"
                            aria-label="Selecionar todos"
                        />
                    </template>

                    <template #cell(select)="{ item }">
                        <b-form-checkbox
                            v-model="selectedIds"
                            :value="item.id || item.agenda_id"
                            aria-label="Selecionar registro"
                        />
                    </template>

                    <template #cell(id)="{ item }">
                        <span>{{ item.id || '' }}</span>
                    </template>

                    <template #cell(start)="{ item }">
                        <span :title="item.start">{{ (item.start) ? formatDateBR(item.start) : '' }}</span>
                    </template>

                    <template #cell(start_time)="{ item }">
                        <span :title="item.start_time">{{ (item.start_time) ? formatTimeBR(item.start_time) : '' }}</span>
                    </template>

                    <template #cell(end_time)="{ item }">
                        <span :title="item.end_time">{{ (item.end_time) ? formatTimeBR(item.end_time) : '' }}</span>
                    </template>

                    <template #cell(desc)="{ item }">
                        <div v-if="item.desc">
                            <div v-if="getFirstImageSrc(item.desc)" class="parecer-thumb-wrap">
                                <img
                                    class="parecer-thumb"
                                    :src="getFirstImageSrc(item.desc)"
                                    :title="stripHtml(item.desc)"
                                    alt="Imagem do parecer"
                                    role="button"
                                    tabindex="0"
                                    @click="openParecerImage(getFirstImageSrc(item.desc))"
                                />
                            </div>
                            <div class="parecer-text" :title="stripHtml(item.desc)">
                                {{ truncate(stripHtml(item.desc), 80) }}
                            </div>
                        </div>
                        <span v-else></span>
                    </template>

                    <template #cell(agreement)="{ item }">
                        <span :title="item.agreement">{{ item.agreement }}</span>
                    </template>

                    <template #cell(conta_pagar_id)="{ item }">
                        <span :title="item.conta_pagar_id">{{ item.conta_pagar_id }}</span>
                    </template>

                    <template #cell(service_value)="{ item }">
                        <span>{{ item.service_value ? formatterFloatBR(item.service_value, 2) : '' }}</span>
                    </template>

                    <template #cell(transfer_amount)="{ item }">
                        <span>{{ item.transfer_amount ? formatterFloatBR(item.transfer_amount, 2) : '' }}</span>
                    </template>

                    <template #cell(is_cancelled)="{ item }">
                        <b-badge :variant="item.is_cancelled ? 'danger' : 'success'">{{ item.is_cancelled ? 'Sim' : 'Não' }}</b-badge>
                    </template>

                    <template #cell(is_billed)="{ item }">
                        <b-badge :variant="item.is_billed ? 'success' : 'danger'">{{ item.is_billed ? 'Sim' : 'Não' }}</b-badge>
                    </template>
                    
                    <!-- Rodapé da tabela -->
                    <template #foot(select)>
                        <span></span>
                    </template>
                    <template #foot(id)>
                        <span></span>
                    </template>
                    <template #foot(agenda_id)>
                        <span></span>
                    </template>
                    <template #foot(is_cancelled)>
                        <span></span>
                    </template>
                    <template #foot(pacient)>
                        <span></span>
                    </template>
                    <template #foot(agreement)>
                        <span></span>
                    </template>
                    <template #foot(start)>
                        <span></span>
                    </template>
                    <template #foot(start_time)>
                        <span></span>
                    </template>
                    <template #foot(end_time)>
                        <span></span>
                    </template>
                    <template #foot(conta_pagar_id)>
                        <div class="text-right font-weight-bold">Total:</div>
                    </template>
                    <template #foot(service_value)>
                        <div class="text-right font-weight-bold">{{ formatterFloatBR(totalServiceValue, 2) }}</div>
                    </template>
                    <template #foot(transfer_amount)>
                        <div class="text-right font-weight-bold">{{ formatterFloatBR(totalTransferAmount, 2) }}</div>
                    </template>
                    <template #foot(desc)>
                        <span></span>
                    </template>
                    <template #foot(is_billed)>
                        <span></span>
                    </template>
                </b-table>
                
                <div class="mt-3 d-flex justify-content-between align-items-center">
                    <span class="mx-3 text-muted">{{ totalRows }} registro(s) encontrado(s)</span>
                    <div v-if="totalRows > perPage">
                        <b-pagination
                            v-model="localCurrentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            @input="handlePageChange"
                            align="right"
                            size="sm"
                            class="mb-0"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.parecer-thumb-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 6px;
}

.parecer-thumb {
    max-width: 80px;
    max-height: 60px;
    width: auto;
    height: auto;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    cursor: pointer;
    object-fit: contain;
}

.parecer-text {
    display: block;
    max-width: 100%;
}

/* Modal ~80% da tela */
:deep(.parecer-image-dialog .modal-dialog) {
    max-width: 80vw;
    width: 80vw;
}

.parecer-image-modal-img {
    max-width: 100%;
    max-height: 75vh;
    object-fit: contain;
}
</style>

<style scoped>
.validation-table {
    font-size: 0.82rem;
}
.validation-table >>> thead th,
.validation-table >>> tbody td {
    padding: 0.3rem 0.45rem;
}
.validation-table >>> .badge {
    font-size: 0.72rem;
}
.validation-table >>> tfoot td {
    padding: 0.5rem 0.45rem;
    background-color: #f8f9fa;
    border-top: 2px solid #dee2e6;
    font-weight: bold;
}
</style>